"use client";
import * as BetterThings from "./better";

const Root = BetterThings.R;
const Image = BetterThings.I;
const Fallback = BetterThings.F;
type RootProps = BetterThings.RProps;
type ImageProps = BetterThings.IProps;
type FallbackProps = BetterThings.FProps;

export {
  Root,
  Image,
  Fallback,
  type RootProps,
  type ImageProps,
  type FallbackProps,
};